//import axios from "axios/index";

const TOGGLE_LEFT = 'TOGGLE_LEFT';
const TOGGLE_RIGHT = 'TOGGLE_RIGHT';
const HIDE_LEFT = 'HIDE_LEFT';
const HIDE_RIGHT = 'HIDE_RIGHT';
const HIDE_ALL = 'HIDE_ALL';


export const state = {
    leftbar: false,
    rightbar: false
};

export const getters = {
    leftbar: state => state.leftbar,
    rightbar: state => state.rightbar,
    visible: state => state.leftbar || state.rightbar
};

// mutations
export const mutations = {

    [TOGGLE_LEFT] (state) {
        state.leftbar = !state.leftbar
    },
    [TOGGLE_RIGHT] (state) {
        state.rightbar = !state.rightbar
    },
    [HIDE_LEFT] (state) {
        state.leftbar = false
    },
    [HIDE_RIGHT] (state) {
        state.rightbar = false;
    },
    [HIDE_ALL] (state) {
        state.leftbar = false;
        state.rightbar = false
    }

};

export const actions = {

    toggleLeft ({ commit, state }) {
        commit(TOGGLE_LEFT,state)
    },
    toggleRight ({ commit, state }) {
        commit(TOGGLE_RIGHT,state)
    },
    hideLeft ({ commit, state }) {
        commit(HIDE_LEFT,state)
    },
    hideRight ({ commit, state }) {
        commit(HIDE_RIGHT,state)
    },
    hideAll ({ commit, state }) {
        commit(HIDE_ALL,state)
    }


};
